// extracted by mini-css-extract-plugin
export default {"applePayViewContainer":"_6a94c4dd","applePayIconContainer":"_4942bc3b","applePayIcon":"_77a3efdc"};